// import React, { useState, useEffect } from 'react';
// import API from '../api/axios';
// import '../style/AdminPromo.css'; // optional for styling

// export default function AdminPromoCodes() {
//   const [promoCodes, setPromoCodes] = useState([]);
//   const [newCode, setNewCode] = useState('');
//   const [discountPercent, setDiscountPercent] = useState(10);
//   const [error, setError] = useState('');

//   const fetchPromoCodes = async () => {
//     try {
//       const res = await API.get('/promo');
//       setPromoCodes(res.data);
//     } catch (err) {
//       console.error("❌ Failed to fetch promo codes", err);
//     }
//   };

//   const createPromo = async () => {
//     if (!newCode || discountPercent < 1 || discountPercent > 100) {
//       return setError("Enter a valid promo code and discount between 1–100%");
//     }

//     try {
//       await API.post('/promo', {
//         code: newCode.toUpperCase(),
//         discountPercent: Number(discountPercent)
//       });
//       setNewCode('');
//       setDiscountPercent(10);
//       setError('');
//       fetchPromoCodes();
//     } catch (err) {
//       console.error("❌ Failed to create promo code", err);
//       setError(err.response?.data?.error || 'Failed to create promo code');
//     }
//   };

//   const deletePromo = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this promo code?")) return;
//     try {
//       await API.delete(`/promo/${id}`);
//       fetchPromoCodes();
//     } catch (err) {
//       console.error("❌ Failed to delete promo", err);
//     }
//   };

//   useEffect(() => {
//     fetchPromoCodes();
//   }, []);

//   return (
//     <div className="admin-promo-container">
//       <h2>🎁 Manage Promo Codes</h2>

//       <div className="create-form">
//         <input
//           type="text"
//           placeholder="Enter promo code (e.g. SAVE10)"
//           value={newCode}
//           onChange={(e) => setNewCode(e.target.value)}
//         />
//         <input
//           type="number"
//           placeholder="Discount %"
//           value={discountPercent}
//           onChange={(e) => setDiscountPercent(e.target.value)}
//         />
//         <button onClick={createPromo}>➕ Create Promo</button>
//         {error && <p className="error">{error}</p>}
//       </div>

//       <table className="promo-table">
//         <thead>
//           <tr>
//             <th>Code</th>
//             <th>Discount (%)</th>
//             <th>Status</th>
//             <th>Created</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {promoCodes.map(promo => (
//             <tr key={promo._id}>
//               <td>{promo.code}</td>
//               <td>{promo.discountPercent}%</td>
//               <td>{promo.active ? '✅ Active' : '❌ Inactive'}</td>
//               <td>{new Date(promo.createdAt).toLocaleDateString()}</td>
//               <td>
//                 <button className="delete-btn" onClick={() => deletePromo(promo._id)}>🗑️ Delete</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }


/// Below is th eupdated cod ewith further development in creation of there promo codes
import React, { useState, useEffect } from 'react';
import API from '../api/axios';
import '../style/AdminPromo.css';

export default function AdminPromoCodes() {
  const [promoCodes, setPromoCodes] = useState([]);
  const [quantityPromos, setQuantityPromos] = useState([]);
  const [cartTotalPromos, setCartTotalPromos] = useState([]);

  const [newCode, setNewCode] = useState('');
  const [discountPercent, setDiscountPercent] = useState(10);

  // const [qtyProductId, setQtyProductId] = useState('');
  const [qtyThreshold, setQtyThreshold] = useState(5);
  const [qtyDiscount, setQtyDiscount] = useState(10);

  const [totalThreshold, setTotalThreshold] = useState(5000);
  const [totalDiscount, setTotalDiscount] = useState(500);

  const [error, setError] = useState('');

  const [qtyPromoCode, setQtyPromoCode] = useState('');
  // const [qtyThreshold, setQtyThreshold] = useState(5);
  // const [qtyDiscount, setQtyDiscount] = useState(10);

  const [cartPromoCode, setCartPromoCode] = useState('');
  const [cartThreshold, setCartThreshold] = useState(500);
  const [cartDiscount, setCartDiscount] = useState(10);



  useEffect(() => {
    fetchAllPromos();
  }, []);

  const fetchAllPromos = async () => {
    try {
      const [promoRes, qtyRes, totalRes] = await Promise.all([
        API.get('/promo'),
        API.get('/promo/quantity-promos'),
        API.get('/promo/cart-total-promos/all')
      ]);
      console.log(totalRes.data)
      setPromoCodes(promoRes.data);
      console.log(promoRes.data)
      setQuantityPromos(qtyRes.data);
      console.log(qtyRes.data)
      setCartTotalPromos(totalRes.data);
    } catch (err) {
      console.error("❌ Failed to fetch promos", err);
    }
  };

  const createPromo = async () => {
    if (!newCode || discountPercent < 1 || discountPercent > 100) {
      return setError("Enter a valid promo code and discount between 1–100%");
    }

    try {
      await API.post('/promo', {
        code: newCode.toUpperCase(),
        discountPercent: Number(discountPercent)
      });
      setNewCode('');
      setDiscountPercent(10);
      setError('');
      fetchAllPromos();
    } catch (err) {
      console.error("❌ Failed to create promo code", err);
      setError(err.response?.data?.error || 'Failed to create promo code');
    }
  };

  // const createQtyPromo = async () => {
  //   try {
  //     await API.post('/promo/quantity-promos', {
  //       productId: qtyProductId,
  //       minQuantity: qtyThreshold,
  //       discountPercent: qtyDiscount
  //     });
  //     setQtyProductId('');
  //     setQtyThreshold(5);
  //     setQtyDiscount(10);
  //     fetchAllPromos();
  //   } catch (err) {
  //     console.error("❌ Failed to create quantity promo", err);
  //   }
  // };

  const createQtyPromo = async () => {
    try {
      await API.post('/promo/quantity-promos', {
        code: qtyPromoCode,
        minQuantity: Number(qtyThreshold),
        discountPercent: Number(qtyDiscount)
      });
      setQtyPromoCode('');
      setQtyThreshold(''); //'' empty string passed by - rajan
      setQtyDiscount('');
      fetchAllPromos();
    } catch (err) {
      console.error("❌ Failed to create quantity promo", err);
    }
  };



  // const createCartTotalPromo = async () => {
  //   try {
  //     await API.post('/promo/cart-total-promos', {
  //       minCartValue: totalThreshold,
  //       discountAmount: totalDiscount
  //     });
  //     setTotalThreshold(5000);
  //     setTotalDiscount(500);
  //     fetchAllPromos();
  //   } catch (err) {
  //     console.error("❌ Failed to create cart total promo", err);
  //   }
  // };

  // const createCartPromo = async () => {
  //   try {
  //     await API.post('/promo/cart-total-promos', {
  //       code: cartPromoCode,
  //       minCartValue: cartThreshold,
  //       discountPercent: cartDiscount
  //     });
  //     setCartPromoCode('');
  //     setCartThreshold(500);
  //     setCartDiscount(10);
  //     fetchAllPromos();
  //   } catch (err) {
  //     console.error("❌ Failed to create cart total promo", err);
  //   }
  // };

  const createCartPromo = async () => {
    const payload = {
      code: cartPromoCode,
      minAmount: Number(cartThreshold),
      discountPercent: Number(cartDiscount),
    };

    console.log("🚀 Sending payload to backend:", payload);

    try {
      await API.post('/promo/cart-total-promos', payload);
      setCartPromoCode('');
      setCartThreshold('');  //'' empty string passed by - rajan
      setCartDiscount('');
      fetchAllPromos();
      console.log("Payload send", payload)
    } catch (err) {
      console.error("❌ Failed to create cart total promo", err.response?.data || err.message);
    }
  };




  // const deletePromo = async (id, type) => {
  //   if (!window.confirm("Are you sure you want to delete this promo?")) return;
  //   try {
  //     let endpoint = '';
  //     if (type === 'standard') endpoint = `/promo/${id}`;
  //     else if (type === 'quantity') endpoint = `/quantity-promos/${id}`;
  //     else if (type === 'total') endpoint = `/cart-total-promos/${id}`;
  //     await API.delete(endpoint);
  //     fetchAllPromos();
  //   } catch (err) {
  //     console.error("❌ Failed to delete promo", err);
  //   }
  // };

  const deletePromo = async (id, type) => {
    if (!window.confirm("Are you sure you want to delete this promo?")) return;

    try {
      let endpoint = '';
      if (type === 'standard') endpoint = `/promo/${id}`;
      else if (type === 'quantity') endpoint = `/promo/quantity-promos/${id}`;
      else if (type === 'total') endpoint = `/promo/cart-total-promos/${id}`;

      await API.delete(endpoint);
      fetchAllPromos();
    } catch (err) {
      console.error("❌ Failed to delete promo", err);
    }
  };


  return (
    <div className="admin-promo-container">
      <h2>🎁 Manage Promo Codes</h2>

      {/* Standard Promo Code */}
      <div className="create-form">
        <h3>🔤 Standard Promo Code</h3>
        <input
          type="text"
          placeholder="Enter promo code (e.g. SAVE10)"
          value={newCode}
          onChange={(e) => setNewCode(e.target.value)}
        />
        <input
          type="number"
          placeholder="Discount %"
          value={discountPercent}
          onChange={(e) => setDiscountPercent(e.target.value)}
        />
        <button onClick={createPromo}>➕ Create Promo</button>
        {error && <p className="error">{error}</p>}
      </div>

      {/* Quantity-Based Discount
      <div className="create-form">
        <h3>📦 Quantity-Based Discount</h3>
        <input
          type="text"
          placeholder="CODE"
          value={qtyProductId}
          onChange={(e) => setQtyProductId(e.target.value)}
        />
        <input
          type="number"
          placeholder="Min Quantity"
          value={qtyThreshold}
          onChange={(e) => setQtyThreshold(e.target.value)}
        />
        <input
          type="number"
          placeholder="Discount %"
          value={qtyDiscount}
          onChange={(e) => setQtyDiscount(e.target.value)}
        />
        <button onClick={createQtyPromo}>➕ Create Quantity Discount</button>
      </div> */}

      {/* Quantity-Based Discount */}
      <div className="create-form">
        <h3>📦 Quantity-Based Discount</h3>
        <input
          type="text"
          placeholder="CODE"
          value={qtyPromoCode}
          onChange={(e) => setQtyPromoCode(e.target.value)}
        />
        <input
          type="number"
          placeholder="Min Quantity"
          value={qtyThreshold}
          onChange={(e) => setQtyThreshold(e.target.value)}
        />
        <input
          type="number"
          placeholder="Discount %"
          value={qtyDiscount}
          onChange={(e) => setQtyDiscount(e.target.value)}
        />
        <button onClick={createQtyPromo}>➕ Create Quantity Discount</button>
      </div>


      {/* Total Amount-Based Discount */}
      {/* <div className="create-form">
        <h3>💰 Cart Total-Based Discount</h3>
        <input
          type="number"
          placeholder="Min Cart Value (₹)"
          value={totalThreshold}
          onChange={(e) => setTotalThreshold(e.target.value)}
        />
        <input
          type="number"
          placeholder="Discount Amount (₹)"
          value={totalDiscount}
          onChange={(e) => setTotalDiscount(e.target.value)}
        />
        <button onClick={createCartTotalPromo}>➕ Create Total Discount</button>
      </div> */}

      {/* Cart Total-Based Discount */}
      <div className="create-form">
        <h3>🛒 Cart Total-Based Discount</h3>
        <input
          type="text"
          placeholder="Promo Code"
          value={cartPromoCode}
          onChange={(e) => setCartPromoCode(e.target.value)}
        />
        <input
          type="number"
          placeholder="Min Cart Value"
          value={cartThreshold}
          onChange={(e) => setCartThreshold(e.target.value)}
        />
        <input
          type="number"
          placeholder="Discount %"
          value={cartDiscount}
          onChange={(e) => setCartDiscount(e.target.value)}
        />
        <button onClick={createCartPromo}>➕ Create Cart Discount</button>
      </div>


      {/* Table: Promo Codes */}
      <h3>🧾 Existing Standard Promo Codes</h3>
      <table className="promo-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Discount (%)</th>
            <th>Status</th>
            <th>Created</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {promoCodes.map(promo => (
            <tr key={promo._id}>
              <td>{promo.code}</td>
              <td>{promo.discountPercent}%</td>
              <td>{promo.active ? '✅ Active' : '❌ Inactive'}</td>
              <td>{new Date(promo.createdAt).toLocaleDateString()}</td>
              <td>
                <button className="delete-btn" onClick={() => deletePromo(promo._id, 'standard')}>🗑️ Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Table: Quantity-Based Promos */}
      <h3>📦 Quantity-Based Promos</h3>
      <table className="promo-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Min Qty</th>
            <th>Discount (%)</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {quantityPromos.map(p => (
            <tr key={p._id}>
              <td>{p.code}</td>
              <td>{p.minQuantity}</td>
              <td>₹{p.discountPercent}</td>
              {/* <td><button className="delete-btn" onClick={() => deletePromo(p._id, 'quantity')}>🗑️ Delete</button></td> */}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Table: Cart Total-Based Promos */}
      <h3>💰 Cart Total-Based Promos</h3>
      <table className="promo-table">
        <thead>
          <tr>
            <th>CODE Name</th>
            <th>Min Cart Value (₹)</th>
            <th>Discount (₹)</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {cartTotalPromos.map(p => (
            <tr key={p._id}>
              <td>{p.code}</td>
              <td>{p.minAmount}</td>
              <td>₹{p.discountPercent}</td>
              {/* <td><button className="delete-btn" onClick={() => deletePromo(p._id, 'total')}>🗑️ Delete</button></td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
